(function() {
  'use strict';

  function GoalsDefinitionController(Router, Event, Goal, Goals, Utils, Notify) {
    var ctrl = this;


    ctrl.loaded = false;

    ctrl.$onInit = function() {
      if (ctrl.action === 'add') {
        var event = new Event();
        event.load(ctrl.eventId, ctrl.user)
          .then(function(event) {
            return event.checkPermission('canAddGoals');
          })
          .then(function() {
            ctrl.title = 'Add new goals to ' + event.eventType.name;
            Utils.setPageTitle(ctrl.title);
            ctrl.eventTypeId = event.doc.eventType;
          })
          .catch(function() {
            Utils.swal({
              title: 'This page could not be loaded!',
              type: 'error',
              showCancelButton: false,
              confirmButtonText: 'OK'
            },
            function() {
              Router.navigate(['/goals/list']);
            });
          });
      } else if (ctrl.action === 'edit') {
        // load the goal
        Goal.find(ctrl.goalId, ctrl.user)
          .then(function(goal) {
            ctrl.goal = goal;
            return ctrl.goal.checkPermission('canEdit');
          })
          .then(function() {
            ctrl.eventTypeId = ctrl.goal.event.doc.eventType;

            _.forEach(ctrl.goal.doc.targets, function(target) {
              if (_.isUndefined(target.title)) {
                target.title = 'Linked Events';
              }
            });

            ctrl.definitions = [ctrl.goal.doc];
            ctrl.title = 'Edit ' + ctrl.goal.doc.title;
            Utils.setPageTitle(ctrl.title);
          })
          .catch(function(error) {
            console.log(error);
            Utils.swal({
              title: 'The goal could not be loaded!',
              type: 'error',
              showCancelButton: false,
              confirmButtonText: 'OK'
            },
            function() {
              Router.navigate(['/goals/list']);
            });
          });
      }
    };

    ctrl.saveDefinitions = function(goalsDefinitions, isValid) {
      if (!isValid) {
        return;
      }

      if (ctrl.action === 'add') {
        Goals.addGoalsToGoalSet(goalsDefinitions, ctrl.eventId, ctrl.sectionId, ctrl.fieldId)
          .then(function() {
            if (ctrl.user) {
              Router.navigate(['/users/edit', ctrl.user, 'goals']);
            } else {
              Router.navigate(['/goals/list']);
            }
          })
          .catch(function(err) {
            Notify.error(err.message);
          });
      } else if (ctrl.action === 'edit') {
        var goal = goalsDefinitions[0];
        var dataToSave = {
          _id: goal._id,
          title: goal.title,
          description: goal.description,
          targets: goal.targets
        };

        Goals.saveViaApi(dataToSave)
          .then(function() {
            if (ctrl.user) {
              Router.navigate(['/users/work', ctrl.user, 'goals', goal._id]);
            } else {
              Router.navigate(['/goals/work', goal._id]);
            }
          })
          .catch(function(err) {
            Notify.error(err.message);
          });
      }
    };
  }

  GoalsDefinitionController.$inject = [
    'Router',
    'EventFactory',
    'GoalFactory',
    'GoalsService',
    'UtilsService',
    'NotifyService'
  ];

  angular.module('component.goals')
    .component('goalsDefinitionComponent', {
      controller: GoalsDefinitionController,
      controllerAs: 'GoalsDefinitionCtrl',
      templateUrl: 'app/components/goals/goals-definition.html',
      bindings: {
        action: '<',
        eventId: '<',
        sectionId: '<',
        fieldId: '<',
        goalId: '<',
        user: '<'
      }
    });
})();
